import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'change_secret_question_modal.title',
  },
  selectQuestionTitle: {
    id: 'change_secret_question_modal.select_question_title',
  },
  selectQuestion: {
    id: 'change_secret_question_modal.select_question',
  },
  confirmPassword: {
    id: 'change_secret_question_modal.confirm_pass',
  },
  reponse: {
    id: 'signup_auth_params_security.response',
  },
  password: {
    id: 'signup_auth_params_security.password',
  },
  requiredField: {
    id: 'required.field',
  },
  cancel: {
    id: 'addContract.cancel',
  },
  valid: {
    id: 'recovery_forgot_password.insert_new_password.title_button_valid',
  },
});
